module.exports = __webpack_public_path__ + "img/mobile/Menus-paytable/correct@2x.png?1.0.24";


//////////////////
// WEBPACK FOOTER
// ./out/img/mobile/Menus-paytable/correct@2x.png
// module id = 708
// module chunks = 0